




































































export default {
	name: 'BursaryListItem',

	props: {
		bursary: {
			required: true,
			type: Object,
		},

		active: {
			default: false,
			required: false,
			type: Boolean,
		},

		sidebar: {
			default: false,
			required: false,
			type: Boolean,
		},
	},

	computed: {
		scrollPosition() {
			return this.$refs.bursaryItem.offsetTop;
		},

		timeLeft() {
			return this.$dayjs().to(this.bursary?.expires, true);
		},
	},

	methods: {
		async goToBursary() {
			this.$emit('click');
			this.$router.push(this.localePath({ path: `/bursaries/${this.bursary.uuid}` }));
		},

		trackApplyButtonEvent() {
			this.$gtm.push({
				event: 'applyButton',
				job_id: this.bursary.uuid,
				user_id: this.$auth.user.uuid,
				job_title: this.bursary.title,
				application_link: null,
			});
		},
	},
};
